/* eslint-disable arrow-body-style */
import React, {
    useContext, useCallback, useEffect, useState, useMemo
} from 'react';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import VehicleCoverage from 'gw-capability-quoteandbind-PremierRV-react/components/VehicleCoverage/VehicleCoverage';
import { CodegenContext } from 'gw-capability-quoteandbind-PremierRV-react/components/CodegenContext';
import { CurrencyInput, TextInput } from '@jutro/components';
import presentationMetadata from './SuccessPage.metadata.json5';
import styles from './SuccessPage.module.scss';
import './SuccessPage.messages';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

const ACCORDION_CARDS = [
    'coverageAccordion',
    'locationAccordionCard',
    'contactAccordionCards'
];

// function renderCellContent(data, index, props) {
//     const { path } = props;

//     return _.get(data, path);
// }

// function renderCoverageAmount(row) {
//     return _.isEmpty(row.amount) ? null : (
//         <CurrencyValue
//             amount={row.amount.amount}
//             currency={row.amount.currency}
//             showFractions
//         />
//     );
// }

function SuccessPage(props) {
    // const translator = useTranslator();
    const breakpoint = useContext(BreakpointTrackerContext);
    const [isPrinting, setPrintingState] = useState(false);
    const { wizardData: submissionVM } = props;
    const { lineName } = useContext(CodegenContext);
    const metadata = presentationMetadata.success;
    const coveragesPath = `lobData.${lineName}.lineCoverages`;

    const periodStartDate = _.get(submissionVM.value, 'baseData.periodStartDate');
    const periodEndDate = _.get(submissionVM.value, 'baseData.periodEndDate');

    useEffect(() => {
        if (isPrinting) {
            // The accordion component requires a new rendering cycle to be trigger,
            // this allows us to wait until that has completed
            const timeoutHandle = setTimeout(() => {
                window.print();
                // Timeout added to delay resetting the print state after the print is called,
                // the print state was being reset before the print preview loaded on actual device
                setTimeout(setPrintingState(false), 1000);
            }, 500);

            return () => clearTimeout(timeoutHandle);
        }

        return _.noop;
    }, [isPrinting]);

    const accountNumber = useMemo(() => {
        return _.get(submissionVM, 'bindData.accountNumber.value');
    }, [submissionVM]);

    const policyNumber = useMemo(() => {
        return _.get(submissionVM, 'bindData.policyNumber.value');
    }, [submissionVM]);

    const handlePrint = useCallback(() => {
        setPrintingState(true);
    }, []);
    // const getLimitValue = (terms, type) => {
    //     if (!_.isEmpty(terms) && terms[0].name === type) {
    //         return terms[0].chosenTermValue;
    //     }

    //     return '-';
    // };

    // const getDeductableValue = (terms, type) => {
    //     if (!_.isEmpty(terms) && terms.length>1 && terms[1]?.name === type) {
    //         return terms[1].chosenTermValue;
    //     }

    //     return '-';
    // };
    // const getCoverage = (coverages, isLineCoverage) => coverages.map((coverage) => ({
    //     name: coverage.name,
    //     coverageType: isLineCoverage ? "Policy" : null,
    //     limit: getLimitValue(coverage.terms, 'Limit'),
    //     deductible: getDeductableValue(coverage.terms, 'Deductible'),
    //     premium: coverage.premium
    // }));

    // const generateVehicleOverrides = () => {
    //     const overrides = submissionVM.value.lobData.recVehLine.lineCoverages.vehicleClausesGroups.map((clause, index) => {
    //         const vehicleCoverage = getCoverage(clause.clausesGroups.coverages)
    //         const vehicleEndoCoverage=getCoverage(clause.clausesGroups.endorsementCoverages)

    //         return {
    //             [`vehicleAccordionCard${index}`]: {
    //                title:clause.coverableName,
    //                visible: false
    //             },
    //             [`vehicleCoverageAccordion${index}`]: {
    //                 // eslint-disable-next-line no-secrets/no-secrets
    //                 visible: false // clause.coverableFixedId===submissionVM.value.lobData.recVehLine.coverables.vehLocRisks[index].fixedID
    //             },
    //             [`vehicleCoverageInfo${index}`]: {
    //                 data: _.concat(vehicleCoverage),
    //                 show: false
    //             },
    //             [`vehicleEndoInfo${index}`]: {
    //                 data: _.concat(vehicleEndoCoverage),
    //                 show: false
    //             },
    //             [`totalPremium`]:{
    //                 value: {
    //                     amount: submissionVM.value.quoteData?.offeredQuotes[0]?.premium.totalBeforeTaxes.amount
    //                   }
    //             },
    //             [`taxes`]:{
    //                 value: {
    //                     amount: submissionVM.value.quoteData?.offeredQuotes[0]?.premium.taxes.amount
    //                   }
    //             },
    //             [`totalCost`]:{
    //                 value: {
    //                     amount: submissionVM.value.quoteData?.offeredQuotes[0]?.premium.total.amount
    //                   }
    //             },
    //             [`vehicleContainer`]:{
    //                 show: false
    //             },
    //             [`contactAccordion`]:{
    //                 visible: false
    //             }
    //         };
    //     });

    //     return Object.assign({}, ...overrides);
    // };  

    // const generateCoverageOverrides = useCallback(
    //     () => {
    //         return {
    //             coverageName: { onCell: renderCellContent },
    //             coverageAmount: { onCell: renderCoverageAmount },
    //         };
    //     },
    //     []
    // );

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onPrint: handlePrint
        },
        resolveComponentMap: {
            vehiclecoverage: VehicleCoverage,
            TextInput,
            CurrencyInput
        }
    };

    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        accountNumberLink: {
            to: `/accounts/${accountNumber}/summary`
        },
        policyNumberLink: {
            to: `/policies/${policyNumber}/documents`
        },
        accordion: {
            closeOthers: !isPrinting,
            accordionStates: isPrinting ? ACCORDION_CARDS : undefined
        },
        clauses_from_VM: {
            path: `${coveragesPath}.coverages`,
        },
        conditions_from_VM: {
            path: `${coveragesPath}.conditions`,
        },
        exclusions_from_VM: {
            path: `${coveragesPath}.exclusions`,
        },
        effectiveDate: {
            value: new Date(periodStartDate.year, periodStartDate.month, periodStartDate.day).toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: '2-digit' })
        },
        coverageEndDate: {
            value: new Date(periodEndDate.year, periodEndDate.month, periodEndDate.day).toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: '2-digit' })
        },
        policyTotalAmount: {
            value: {
                ... (_.get(submissionVM.value, 'quoteData.offeredQuotes[0].premium.total')),
                currency: (_.get(submissionVM.value, 'quoteData.offeredQuotes[0].premium.total')?.currency?.toUpperCase())
            }
        }
        // ...generateCoverageOverrides(translator),
        // ...generateVehicleOverrides()
    };

    return (
        <ViewModelForm
            uiProps={metadata.content}
            model={submissionVM}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

SuccessPage.propTypes = wizardProps;
export default SuccessPage;
